import React, { useEffect } from "react";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { Link, redirect, useNavigate } from "react-router-dom";
import { get_dashboard_index_data } from "../../store/reducers/dashboardReducer";
import { Package, PackageMinus, PackageOpen, PackagePlus } from "lucide-react";
import { Button } from "../ui/button";
import { formatCurrency } from "../../utils/currencyUtils";
import { useCurrency } from "../../hooks/useCurrency";
const Index = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const { totalOrder, pendingOrder, recentOrders, cancelledOrder } =
    useSelector((state) => state.dashboard);
  const { currencyCode, exchangeLoaded } = useCurrency();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(get_dashboard_index_data(userInfo.id));
  }, []);
  const redirect = (ord) => {
    let items = 0;
    for (let i = 0; i < ord.products.length; i++) {
      items = ord.products[i].quantity + items;
    }
    navigate("/payment", {
      state: {
        price: ord.price,
        items,
        orderId: ord._id,
        customerName: ord.shippingInfo.name,
        customerPhone: ord.shippingInfo.phone

      },
    });
  };
  return (
    <div>
      <div className="grid grid-cols-3 md:grid-cols-1 gap-4 sm:gap-2 mb-4 sm:px-4 sm:mb-2">
        <div className="flex tems-center p-5 bg-white border border-gray-100 shadow-sm  rounded-md gap-5">
          <div className="w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl ">
            <span className="text-xl">
              <PackagePlus size={32} />
            </span>
          </div>
          <div className="flex flex-col justify-start items-start sm:flex-row sm:items-center text-gray-900">
            <h2 className="text-3xl font-bold sm:mr-2">{totalOrder}</h2>
            <span>Orders</span>
          </div>
        </div>
        <div className="flex  items-center p-5  bg-white border border-gray-100 shadow-sm  rounded-md gap-5">
          <div className=" w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl ">
            <span className="text-xl ">
              <Package size={32} />
            </span>
          </div>
          <div className="flex flex-col justify-start items-start sm:flex-row sm:items-center text-gray-900">
            <h2 className="text-3xl font-bold sm:mr-2">{pendingOrder}</h2>
            <span>Pending Orders</span>
          </div>
        </div>
        <div className="flex  items-center p-5 bg-white border border-gray-100 shadow-sm  rounded-md gap-5">
          <div className="w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl ">
            <span className="text-xl">
              <PackageMinus size={32} />
            </span>
          </div>
          <div className="flex flex-col justify-start items-start sm:flex-row sm:items-center text-gray-900">
            <h2 className="text-3xl font-bold sm:mr-2">{cancelledOrder}</h2>
            <span>Cancelled Orders</span>
          </div>
        </div>
      </div>
      <div className=" bg-white border border-gray-100 shadow-sm  p-5 sm:mx-4 rounded-md">
        <h2 className="text-lg font-semibold text-gray-900">Recent Orders</h2>
        <div className="pt-4">
          <div className="relative overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-700">
              <thead className="text-xs text-gray-700 uppercase  bg-gray-50 ">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Order Id
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Price
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Payment status
                  </th>
                  {/* <th scope="col" className="px-6 py-3">
                    Order status
                  </th> */}
                  <th scope="col" className="px-6 py-3">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {recentOrders.map((o, i) => (
                  <tr key={i} className="text-gray-700 bg-white border-b border-gray-100">
                    <td scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                      {o._id}
                    </td>
                    <td scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                      {formatCurrency(o.price, currencyCode, exchangeLoaded)}
                    </td>
                    <td scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                      {o.payment_status}
                    </td>
                    <td scope="row" className="px-6 py-4 flex gap-2">
                      <Link to={`/dashboard/order/details/${o._id}`}>
                        <span className="bg-gray-100 text-gray-700 hover:bg-gray-200 text-xs whitespace-nowrap font-medium px-4 py-1 rounded transition-colors">
                          View
                        </span>
                      </Link>
                      {o.payment_status !== "paid" && (
                        <span
                          onClick={() => redirect(o)}
                          className="whitespace-nowrap cursor-pointer bg-indigo-600 text-white hover:bg-indigo-700 text-xs font-medium px-4 py-1 rounded transition-colors"
                        >
                          Pay Now
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
